var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('swipe',{staticClass:"my-swipe"},[_c('swipe-item',{staticClass:"slide1"}),_vm._v(" "),_c('swipe-item',{staticClass:"slide2"})],1),_vm._v(" "),_c('div',{staticClass:"mobile-banner"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-668e4488","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home/components/banner1.vue
// module id = LsFx
// module chunks = 1